import { IEvent } from "@quest/adapter-interface";
import { SpineBase } from "@quest/base-core";
import { BaseViewBehavior } from "@quest/murka-games-behavior-panther";
import { FreeGameModel } from "@quest/slot-core";
 
export class StickyFeatureView extends BaseViewBehavior {
    protected fgModel: FreeGameModel;
    constructor(viewJson: any) {
        super(viewJson);
    }
    protected resize(evt: IEvent): void {
        //do noting will resize as per freegame view
    }

    public createSpineClone(stoneAnimId: any): SpineBase {
        const spine: any = this.createSpine(stoneAnimId);
        return spine;
    }
 
 
 
}
 
 